import React, { FC } from "react";
import "./styles/landing-page.scss";
import styles from "./styles.module.scss";
import classnames from "classnames";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";

import { Footer } from "./footer";
export const Privacy: FC = () => {
  const navClasses = classnames(
    "container-fluid",
    "navbar navbar-expand-lg navbar-light bg-white ",
    "mb-3",
    styles.navWrapper
  );
  return (
    <>
      <nav className={navClasses}>
        <a className="navbar-brand" href="/">
          <Logo className="m-0 text-border" width={40} height={40} />
        </a>
      </nav>

      <div className="container-fluid ">
        <header className="masthead text-white text-center mb-5">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col">
                <Logo width={140} height={140} className="text-success" />
                <h1 className="mb-3 ">privacy policy</h1>
                <p className="text-monospace">
                  <strong>as of: Oct 2020</strong>
                </p>
              </div>
            </div>
          </div>
        </header>

        <section>
          <div className="container">
            <div className="row">
              <div className="col">
                <p>
                  Glowplug "the App” provides the ability to create a customer
                  referral program "the Service" to merchants who use Shopify to
                  power their stores. This Privacy Policy describes how personal
                  information is collected, used, and shared when you install or
                  use the App in connection with your Shopify-supported store.
                </p>

                <h3 className="mt-5">Personal Information the App Collects</h3>
                <p>
                  When you install the App, we are automatically able to access
                  certain types of information from your Shopify account:
                </p>
                <ul>
                  <li>
                    - Basic Store Information including store domain, owner
                    email address, and Shopify subscription plan level
                  </li>
                  <li>
                    - Customer Information including customer name and email
                    address
                  </li>
                  <li>
                    - Order Information including order name/number, financial
                    status, fulfillment status, related customer, and total
                    price
                  </li>
                  <li>
                    - Product Information including product name, variant
                    information, pricing, and imagery
                  </li>
                  <li>
                    - Theme Information including HTML for current live theme
                  </li>
                  <li>
                    - Discount Information including discount codes and their
                    corresponding rules
                  </li>
                </ul>
                <p>
                  Additionally, we collect the following types of personal
                  information from your customers once you have installed the
                  App: Information about individuals who sign up as advocates or
                  friends for the referral program, such as their name, email
                  address, IP address, and information about the cookies
                  installed on the particular device.
                </p>
                <p>
                  We collect personal information directly from the relevant
                  individual, or using the following technologies: “Cookies” are
                  data files that are placed on your device or computer and
                  often include an anonymous unique identifier. For more
                  information about cookies, and how to disable cookies, visit
                  http://www.allaboutcookies.org. “Log files” track actions
                  occurring on the Site, and collect data including your IP
                  address, browser type, Internet service provider,
                  referring/exit pages, and date/time stamps. “Web beacons,”
                  “tags,” and “pixels” are electronic files used to record
                  information about how you browse the Site.
                </p>

                <h3 className="mt-5">
                  How Do We Use Your Personal Information?
                </h3>
                <p>
                  We use the personal information we collect from you and your
                  customers in order to provide the Service and to operate the
                  App. Additionally, we use this personal information to
                  communicate with you.
                </p>

                <h3 className="mt-5">Sharing Your Personal Information</h3>
                <p>
                  We never share your personal information or the information
                  collected from your store's users with any third parties,
                  except as legally required (see below).
                </p>
                <p>
                  Finally, we may also share your Personal Information to comply
                  with applicable laws and regulations, to respond to a
                  subpoena, search warrant or other lawful request for
                  information we receive, or to otherwise protect our rights.
                </p>

                <h3 className="mt-5">Your Rights</h3>
                <p>
                  If you are a European resident, you have the right to access
                  personal information we hold about you and to ask that your
                  personal information be corrected, updated, or deleted. If you
                  would like to exercise this right, please contact us through
                  the contact information below.
                </p>
                <p>
                  Additionally, if you are a European resident we note that we
                  are processing your information in order to fulfill contracts
                  we might have with you, or otherwise to pursue our legitimate
                  business interests listed above. Additionally, please note
                  that your information will be transferred outside of Europe,
                  including to Canada and the United States.
                </p>

                <h3 className="mt-5">Data Retention</h3>
                <p>
                  When you use the App, we will maintain your information for
                  our records unless and until you ask us to delete this
                  information. Additionally, 48 hours after uninstalling the
                  app, we will redact all personal information stored.
                </p>

                <h3 className="mt-5">Changes</h3>
                <p>
                  We may update this privacy policy from time to time in order
                  to reflect, for example, changes to our practices or for other
                  operational, legal or regulatory reasons.
                </p>

                <h3 className="mt-5">Contact Us</h3>
                <p>
                  For more information about our privacy practices, if you have
                  questions, or if you would like to make a complaint, please
                  contact us by e-mail at info@glowplug.app.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Privacy;
